export default __webpack_public_path__ + "static/media/Member_Filled_Active.4a100fa7.svg";